<div class="page-layout blank p-24 inner-scroll" fusePerfectScrollbar>
  <loading-component [complete]="!loading" [style]="embedded ? 'table-inline' : null"></loading-component>

  <div *ngIf="!embedded && !loading" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="8px">
    <button mat-mini-fab color="primary" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h3 class="m-0">{{ device.name + ' (' + (device.serial) + ')' }}</h3>
  </div>

  <div fxLayout="row wrap" *ngIf="!loading">
    <!-- photo tile, should a photo exist -->
    <fuse-widget *ngIf="img" fxFlex="50" fxFlex.gt-xs="33" fxFlex.gt-md="20" fxFlex.gt-lg="15" fxFlex.gt-xl="10"  fxLayout="column">
      <img class="img-tile clickable" [src]="img" (click)="openGallery(img)">
    </fuse-widget>

    <!-- the rest of the tiles -->
    <fuse-widget *ngFor="let tile of deviceTiles" fxFlex="50"  fxFlex.gt-xs="33" fxFlex.gt-md="20" fxFlex.gt-lg="15" fxFlex.gt-xl="10" fxLayout="column">
      <div class="tile-container fuse-widget-front mat-elevation-z2">
          <div class="tile-header">
            <div class="tile-title">{{ tile.title }}</div>
          </div>
          <div class="tile-body">
            <div class="icon-wrapper">
              <icon [class]="tile.icon">
                <div class="badge-wrapper" *ngIf="tile.badge">
                  <div>{{tile.badge}}</div>
                </div>
              </icon>
            </div>
            <div class="tile-content" [class.clickable]="tile.clickable" (click)="tile.clickHandler && tile.clickHandler($event)" >
              {{tile.data}}
            </div>
          </div>
        </div>
    </fuse-widget>
    <fuse-widget *ngIf="device.mapping?.tiles?.includes('images')" fxFlex="50" fxFlex.gt-xs="33" fxFlex.gt-md="20" fxFlex.gt-lg="15" fxFlex.gt-xl="10" fxLayout="column" (click)="showImageViewer()">
      <div class="tile-container fuse-widget-front mat-elevation-z2 gallery">
        <div class="tile-header">
          <div class="tile-title">Image Viewer</div>
        </div>
        <div class="tile-body-gallery">
          <div class="icon-wrapper">
            <icon class="fa-solid fa-gallery-thumbnails">
            </icon>
          </div>
        </div>
      </div>
    </fuse-widget>
  </div>  
</div>
